const algoliasearch = require("algoliasearch");

const constants = {
  APP_ID: "TYC5NS4XAD",
  SEARCH_KEY: "2444a4ec5fb0eaa18977dcb287f80b2a",
  INDEX_NAME: "jobs_dev",
  client: null
};
let index = null;

const init = () => {
  constants.client = algoliasearch(constants.APP_ID, constants.SEARCH_KEY);
  index = constants.client.initIndex(constants.INDEX_NAME);
};

const search_for = (query, options) => {
  return index.search(query, options);
};

const has_initiated = () => {
  return index !== null;
};

const Search = {
  init,
  search_for,
  has_initiated
};

export default Search;
